import { UserAccessHandler } from '@sennder/shell-utilities'

import { getStateData } from '@/store'
import { featureFlag } from '@/services/featureFlagProvider'
import { findCharteringTeam } from '@/services/teamsService'

/**
 * Access handlers are functions which return a boolean. They can be used as menu visibility handlers, and called in route guards.
 *
 * NAMING CONVENTIONS
 *
 * Access handler name should be a sentence which describes what access it checks, or user role it checks.
 *
 * - userIs{Role}: Check if the user has a specific role
 * - canAccess{Page}: Check if the user has access to the page
 */

export const canAccessCharteringPages = (() => {
  const teams = getStateData().teams

  return !!findCharteringTeam(teams || [])
}) satisfies UserAccessHandler

export const canAccessTransportAnalysis: UserAccessHandler = () => {
  return !!featureFlag.getFeatureFlag('DISPLAY_TRANSPORT_ANALYSIS')
}

export const canAccessSpotAutobidding: UserAccessHandler = () => {
  return !!featureFlag.getFeatureFlag('ENABLE_SPOT_AUTOBIDDING')
}

export const canAccessExperiments: UserAccessHandler = () => {
  return !!featureFlag.getFeatureFlag('ENABLE_EXPERIMENTS-PAGE')
}
